/**
 * A named factory table. This is the single extension seam used by prefabs,
 * game modes and gadgets: to add new content you register a factory under a
 * key, and level data references that key as a string. Nothing else changes.
 */
export class Registry {
  constructor(label = 'registry') {
    this.label = label;
    this._entries = new Map();
  }

  /**
   * @param {string} key
   * @param {Function} factory
   * @param {object} [meta] optional descriptive data (used by editors/UI)
   */
  register(key, factory, meta = {}) {
    if (this._entries.has(key)) {
      console.warn(`[${this.label}] overwriting "${key}"`);
    }
    this._entries.set(key, { factory, meta });
    return this;
  }

  has(key) { return this._entries.has(key); }

  get(key) {
    const e = this._entries.get(key);
    if (!e) throw new Error(`[${this.label}] unknown key "${key}". Known: ${[...this._entries.keys()].join(', ')}`);
    return e.factory;
  }

  meta(key) { return this._entries.get(key)?.meta ?? {}; }

  create(key, ...args) { return this.get(key)(...args); }

  keys() { return [...this._entries.keys()]; }
}
